var _style, _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.1 40.5",
    style: {
      enableBackground: "new 0 0 48.1 40.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#137EBB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.2,18.4C43.2,7.9,34.6,0,24.1,0C12.9,0,3.8,9.1,3.8,20.2s9.1,20.2,20.3,20.2c0.6,0,1.2,0,1.8-0.1 c0.6-0.1,1.1-0.1,1.7-0.2l0.2,0C38.1,38.2,45.2,28.9,44.2,18.4z M35.3,34.1c-0.3,0.3-0.6,0.5-1,0.8l-0.1,0.1 c-0.4,0.3-0.8,0.5-1.2,0.7c-0.4,0.2-1,0.5-1.4,0.7l0.2,0.5h0l-0.2-0.5c-0.4,0.2-1,0.4-1.6,0.6c-0.4,0.2-0.9,0.3-1.3,0.4l-0.1,0 c-0.5,0.1-0.9,0.2-1.5,0.3c-0.5,0.1-1,0.2-1.5,0.2c-1,0.1-2,0.1-3.1,0c-0.5,0-1-0.1-1.6-0.2c-0.5-0.1-0.9-0.2-1.5-0.3 c-0.5-0.1-0.9-0.3-1.3-0.4l-0.1,0c-0.4-0.2-0.9-0.3-1.3-0.5c-0.4-0.2-1-0.5-1.4-0.7L15,36.2c0,0,0,0,0,0l0.3-0.5 c-0.4-0.2-0.9-0.6-1.3-0.8l-0.2-0.1c-0.3-0.2-0.6-0.5-1-0.7v-5.3c0-3.7,3-6.7,6.7-6.7h9.2c3.7,0,6.7,3,6.7,6.7V34.1z M37.7,31.6 v-2.9c0-5-4.1-9.1-9.1-9.1h-9.2c-5,0-9.1,4.1-9.1,9.1v2.9c-5.8-7-5.4-17.5,1.1-24c6.9-6.9,18.2-6.9,25.1,0 C43.2,14.1,43.6,24.6,37.7,31.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.1,4.4c-3.9,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1c3.9,0,7.1-3.2,7.1-7.1C31.2,7.6,28,4.4,24.1,4.4z M24.1,16.2 c-2.6,0-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7C28.7,14.1,26.6,16.2,24.1,16.2z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-icon.69edf86f.svg";
export { ForwardRef as ReactComponent };